export function viewThreeSetStep(state, payload) {
  return {
    ...state,
    designChapter: updateDesignChapter(state.designChapter, payload),
  };
}

function updateDesignChapter(designChapter, payload) {
  //also used to check if option is set
  let isStreakBroken = undefined;

  const updateInSlideTree = (slideTree) => {
    return slideTree.map((groupItem) => {
      return {
        ...groupItem,
        groupNodes: groupItem.groupNodes.map(updateGroupNode),
      };
    });
  };

  const updateGroupNode = (groupNode) => {
    return {
      ...groupNode,
      nodeComponents: groupNode.nodeComponents.map(updateNodeComponent),
    };
  };

  const updateNodeComponent = (nodeComponent) => {
    if (nodeComponent.droppedId === null && isStreakBroken === undefined) {
      if (nodeComponent.answerId.includes(payload)) {
        isStreakBroken = false;
        return {...nodeComponent, droppedId: payload, showTooltip: false};
      } else {
        isStreakBroken = true;
        return {...nodeComponent, droppedId: payload, showTooltip: true};
      }
    }
    return {...nodeComponent, showTooltip: false};
  };

  const updateCurrentStreak = (currentStreak) => {
    if (isStreakBroken) return 0;
    else return currentStreak + 1;
  };

  return {
    ...designChapter,
    currentView: {
      ...designChapter.currentView,
      slideTree: updateInSlideTree(designChapter.currentView.slideTree),
      options: {
        ...designChapter.currentView.options,
        list: setDroppedOptionVisibility(
          designChapter.currentView.options.list,
          payload
        ),
      },
      ...updateCompleteFeedbackData(designChapter.currentView, isStreakBroken),
    },
    currentStreak: updateCurrentStreak(designChapter.currentStreak),
    longestStreak: updateLongestStreak(designChapter, isStreakBroken),
  };
}

function setDroppedOptionVisibility(list, optionId) {
  return list.map((listItem) => {
    if (listItem.id === optionId) return {...listItem, visible: false};
    return {...listItem};
  });
}

function updateLongestStreak({currentStreak, longestStreak}, isStreakBroken) {
  if (isStreakBroken || longestStreak > currentStreak) return longestStreak;
  else return currentStreak + 1;
}

function updateCorrectCount(correctNodeComponents, isStreakBroken) {
  if (isStreakBroken || isStreakBroken === undefined)
    return correctNodeComponents;
  return correctNodeComponents + 1;
}

function updateCompleteFeedbackData({correctNodeComponents}, isStreakBroken) {
  if (correctNodeComponents != undefined) {
    if (isStreakBroken || isStreakBroken === undefined)
      return {correctNodeComponents};
    return {correctNodeComponents: correctNodeComponents + 1};
  }
  return {};
}
